import { AppDefinition } from '../../types/apps';

export const BankAppDefinition: AppDefinition = {
  appId: 'bank',
  name: 'Banking',
  version: '2.0.0',
  description: 'Bank account transactions, spending analysis, and financial insights via Plaid',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Bank',
    phosphorWeight: 'duotone',
    color: '#10b981',
  },
  component: 'bank',
  entityTypes: ['Integration.Plaid', 'BankAccount', 'BankTransaction'],
  requiresProps: false,
  requiresEntity: false,
  experimental: true,
  hidden: true,
};
